import api from "../api";

export const getHouseProfile = async (userId) => {
    const res = await api.get(`/auth/getHouseOwnerProfileData/${userId}`);
    return res.data;
}

export const updateHomeOwnerProfile = async (userId, data) => {
    const res = await api.post(`/auth/updateHomeOwnerProfile/${userId}`, data);
    return res.data;
}

export const getShovellerProfile = async (userId) => {
    const res = await api.get(`/auth/getShovellerProfileData/${userId}`);
    return res.data;
}

export const updateShovellerProfile = async (userId, data) => {
    const res = await api.post(`/auth/updateShovellerProfile/${userId}`, data);
    return res.data;
}
